export default __webpack_public_path__ + "static/workable-0e610b3aeb61535cfe3a42487e37ed1f.png";